import {useEffect} from 'react';

import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import SettingsCountryFilters from './SettingsCountryFilters';
import SettingsCountryTable from './SettingsCountryTable';
import useCountryUpdate from './useCountryUpdate';

const CountryList = ({
  setCountryTotal,
}: {
  setCountryTotal: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const {
    list,
    isSearch,
    isLoading,
    currentFilters,
    clearFilters,
    selectCurrentFilters,
    pageInfo,
    isPageReset,
    setPage,
    searchTerm,
    handleSearch,
  } = useCountryUpdate();

  useEffect(() => {
    const tots = pageInfo.total ? ` (${pageInfo.total.toLocaleString()})` : '';
    setCountryTotal(tots);
  }, [pageInfo, setCountryTotal]);

  const loadedContent = list?.length ? (
    <SettingsCountryTable list={list} />
  ) : (
    <div className="flex items-center gap-1 justify-center mt-5">
      <p className="text-gray-800">
        {searchTerm.trim()
          ? 'No countries match your search.'
          : 'No Countries found.'}
      </p>
    </div>
  );

  return (
    <>
      <SettingsCountryFilters
        currentFilters={currentFilters}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        searchTerm={searchTerm}
        onSearchChange={handleSearch}
      />

      <main className="pt-5 py-10 overflow-x-auto">
        {isLoading ? (
          <div className="min-w-full">
            <TableSkeleton />
          </div>
        ) : (
          loadedContent
        )}

        {list && list.length ? (
          <Pagination
            isPageReset={isPageReset}
            onPageChange={
              ((params) =>
                setPage(
                  params.page as number,
                )) as PaginationProps['onPageChange']
            }
            total={pageInfo?.total}
            isSearch={isSearch}
          />
        ) : null}
      </main>
    </>
  );
};

export default CountryList;
